<div style="position: relative; margin-bottom: 20px;">
  <!-- Thumbnail + play button view -->
  <button type="button" class="btn-reset" *ngIf="!showVideo && withImage" [attr.aria-label]="'a11y.play_video' | translate" (click)="playVideo()">
    <img [src]="slide?.image?.path || 'assets/img/placeholder.jpg'" alt="thumbnail" width="100%" />
    <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
      <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="45" height="45" rx="22.5" fill="#2799FA" />
        <path d="M18 15V31L31 23L18 15Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
  </button>

  <!-- Vimeo iframe view -->
  <div style="position: relative;" *ngIf="embedUrl">
    <iframe
        [id]="getVimeoID()"
        mozallowfullscreen="true"
        webkitallowfullscreen="true" allowfullscreen="true"
        [src]="embedUrl" width="100%" height="240" frameborder="0"
      allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
  </div>

  <!-- Native HTML5 video (api.backend SystemFile MP4s — PFT introslides) -->
  <div style="position: relative;" *ngIf="!embedUrl && videoSrc">
    <video
      [src]="videoSrc"
      width="100%"
      height="240"
      controls
      playsinline
      preload="metadata"
      style="display: block; background: #000;"
    ></video>
  </div>

  <!-- Error message when video data is missing -->
  <div *ngIf="!embedUrl && !videoSrc" style="padding: 20px; text-align: center; background: #f5f5f5; border-radius: 8px;">
    <p style="color: #888; margin: 0;">Video not available</p>
  </div>
</div>